import { Injectable, Signal, signal } from '@angular/core';

@Injectable()
export class SupplierIdService {
  readonly supplierId = signal<Signal<number | undefined>>(signal(undefined));

  setSupplierId(supplierId: Signal<number | undefined>) {
    this.supplierId.set(supplierId);
  }
}
